var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-logo-dashboard"},[_c('CRow',{staticClass:"w-100"},[_c('img',{attrs:{"src":_vm.bannerSrc,"width":"100%","height":"100%","alt":"logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }